import { render, staticRenderFns } from "./SidebarSubMenu.vue?vue&type=template&id=6d9d516c"
import script from "./SidebarSubMenu.vue?vue&type=script&lang=js"
export * from "./SidebarSubMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports